import React from "react";

export const SentivoLogo = ({ className = "h-8 w-auto", variant = "dark" }) => {
  const stroke = variant === "light" ? "#FAF9F6" : "#2C3E35";
  const accent = "#D16C4D";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="sentivo-logo">
      <svg viewBox="0 0 40 40" className="h-8 w-8" aria-hidden="true">
        {/* Bloom mark - three soft petals */}
        <g fill="none" strokeWidth="2.2" strokeLinecap="round">
          <path d="M20 30 C 12 26, 8 18, 12 10" stroke={stroke} />
          <path d="M20 30 C 28 26, 32 18, 28 10" stroke={stroke} />
          <path d="M20 30 C 20 22, 20 16, 20 8" stroke={accent} />
          <circle cx="20" cy="30" r="2.2" fill={accent} stroke="none" />
        </g>
      </svg>
      <div className="leading-none">
        <div
          className="font-serif text-xl tracking-tight"
          style={{ color: variant === "light" ? "#FAF9F6" : "#1A211D" }}
        >
          Sentivo<span style={{ color: accent }}>Tech</span>
        </div>
        <div
          className="text-[10px] tracking-[0.22em] uppercase mt-0.5"
          style={{ color: variant === "light" ? "rgba(250,249,246,0.6)" : "#5C6B61" }}
        >
          AI · Health · Wellness
        </div>
      </div>
    </div>
  );
};
